import React from 'react';
import {vars, style, classes} from './doppe-viewer-divider.st.css';
import {colorIsDark, evaluateFunction, Values} from "@wix/devzai-utils-common";
import {BymoPageStyleScope, BymoPageStyleScopeColors, useBymoPageScopeColor} from "../bymo-page-style/bymo-page-style";

export const DoppeViewerDividerSkin = {
    HorizontalLine: 'horizontalLine',
    GradientLine: 'gradientLine'
} as const;

export type DoppeViewerDividerSkin = Values<typeof DoppeViewerDividerSkin>;

export const DoppeViewerDivider = React.memo(function DoppeViewerDivider (props: DoppeViewerDivider.Props) {
    const {
        skin,
        style: styleProp,

        className,
        ...htmlAttributes
    } = props;

    const textColor = useBymoPageScopeColor(BymoPageStyleScopeColors.TextColor, BymoPageStyleScope.PageContent);

    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, {skin: skin}, className)}
            style={{
                [vars.color]: evaluateFunction(() => {
                    switch (skin) {
                        case DoppeViewerDividerSkin.HorizontalLine:
                        case DoppeViewerDividerSkin.GradientLine:
                            return colorIsDark(textColor) ? 'rgba(0, 0, 0, 0.1)' : 'rgba(255, 255, 255, 0.2)';
                    }
                })
            }}
        />
    );
});

export namespace DoppeViewerDivider {

    export interface Props extends React.HTMLAttributes<any> {
        skin: DoppeViewerDividerSkin;
    }
}
